<template>
  <div id="menu-language-prompt" @click="closeView" @keydown.escape="closeView">
    <language-list :class="{ 'login-prompt': loginPrompt }" @row-clicked="rowClicked" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import LanguageList from "@/components/language-prompt-list.vue";

export default Vue.extend({
  name: "component-menu-language-prompt",
  components: { LanguageList },
  props: {
    loginPrompt: Boolean,
  },
  methods: {
    rowClicked(language: "zh_TW" | "ja_JP") {
      this.$i18n.locale = language;
      this.$emit("select-and-close-view");
    },
    closeView() {
      this.$emit("close-view");
    },
  },
});
</script>

<style lang="scss" scoped>
@import "~@vacancorp/vacan-scss/mixins/media-query.scss";

#menu-language-prompt {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100%;
  background-color: transparent;

  #menu-language-prompt-list {
    position: absolute;
    right: 16px;
    top: calc(#{$header-height} - 8px);
    background-color: white;
    width: 299px;
    height: 89px;
    overflow-y: auto;
    background: #ffffff;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    padding: 16px 0 16px 0;

    @include media-query(xs) {
      width: 100%;
      height: calc(100vh - 87px);
      right: 0px;
    }

    &.login-prompt {
      position: relative;
      width: 177px;
      height: calc(100px - 24px);
      position: absolute;
      left: calc(50% - 80px);
      top: calc(50% + 110px);
      padding: 12px 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
</style>
